import { render } from "./Footer.vue?vue&type=template&id=4b0ba672&scoped=true&async=true"
import script from "./Footer.vue?vue&type=script&async=true&lang=js"
export * from "./Footer.vue?vue&type=script&async=true&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=4b0ba672&async=true&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0ba672"]])

export default __exports__